// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface MessageSendFailedModalProps {
	hasAttachments?: boolean;
}

export const MessageSendFailedModal = observer(({hasAttachments}: MessageSendFailedModalProps) => {
	const {t} = useLingui();
	return (
		<GenericErrorModal
			title={t`Your message didn't send`}
			message={
				hasAttachments
					? t`One or more attachments couldn't be read or uploaded. The file may have been moved or deleted. Add it again and retry.`
					: t`We hit a snag. Try sending your message again.`
			}
		/>
	);
});
